import Level from '../core/level.js'

const level = new Level({
    name: 'example_bad_choices'
})


function randomChoice () {
    return Math.floor(Math.random() * 1000)
}


level.addQuestion({
    generator: function (q) {
        q.addText('Hello')
        q.addBadChoices(true, '44', 78, 95, 'tototo', randomChoice)
        q.answer = 'eorjgozjofj'
    },
    times: 3
})



export default level

